import { OrgId, UserId } from '@csp/csp-common-model';

export type AuditTrailReportFilterCriteria = {
  userIds: UserId[];
  countryOrgIds: OrgId[];
  siteOrgIds: OrgId[];
};

const empty = (): AuditTrailReportFilterCriteria => ({
  userIds: [],
  countryOrgIds: [],
  siteOrgIds: [],
});

export const AuditTrailReportFilterCriteria = {
  empty,
};
